// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a5fac29","455":"c3c81715","977":"a5040ef6"}[chunkId] + ".chunk.js";
};